import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Ground from './pages/Ground';
import Equipment from './pages/Equipment';
import CrossBorder from './pages/CrossBorder';
import GlobalTech from './pages/GlobalTech';
import Quote from './pages/Quote';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-bone">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ground" element={<Ground />} />
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/cross-border" element={<CrossBorder />} />
            <Route path="/global-tech" element={<GlobalTech />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
